import { render, staticRenderFns } from "./DeleteXtendConfirm.vue?vue&type=template&id=3a610f72&"
import script from "./DeleteXtendConfirm.vue?vue&type=script&lang=js&"
export * from "./DeleteXtendConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports